// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rgKk","left":"styles_left__2PRx4","desktopActions":"styles_desktopActions__3wRjP","title":"styles_title__3t0FR"};